import Header from "@/components/kohinoor/Header";
import Hero from "@/components/kohinoor/Hero";
import ContactCard from "@/components/kohinoor/ContactCard";
import FraudWarning from "@/components/kohinoor/FraudWarning";
import TropicalDivider from "@/components/kohinoor/TropicalDivider";
import Footer from "@/components/kohinoor/Footer";

export default function KohinoorLanding() {
  return (
    <main data-testid="kohinoor-landing" className="bg-[#fdfbf6] text-[#0a0a0a]">
      <Header />
      <Hero />
      <ContactCard />
      <TropicalDivider className="py-2" />
      <FraudWarning />
      <Footer />
    </main>
  );
}
